import React, { useState, useRef, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import { SERVER_BASE_URL } from '../../utils/api';
import DashboardHeader from '../../components/dashboard/DashboardHeader';
import DashboardFooter from '../../components/dashboard/DashboardFooter';
import QRCode from 'react-qr-code';

// Кнопка "Стать Партнёром" для статуса Спорт
const BecomePartnerCard = styled.div`
  background: linear-gradient(135deg, #ff6b35 0%, #f7931a 100%);
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
  text-align: center;
  color: white;
  margin-bottom: 20px;
`;

const BecomePartnerTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: 600;
`;

const BecomePartnerText = styled.p`
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 15px;
`;

const BecomePartnerButton = styled.button`
  background: white;
  color: #ff6b35;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const MarketingInfoCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-left: 4px solid #ff6b35;
  padding: 20px 24px;
  border-radius: 12px;
  margin-bottom: 20px;

  h4 {
    margin: 0 0 10px;
    font-size: 16px;
    color: #333;
  }

  p {
    margin: 0 0 12px;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }

  a {
    color: #ff6b35;
    font-weight: 600;
    text-decoration: none;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const DashboardWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
`;

const DashboardContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
  
  @media (max-width: 410px) {
    padding: 15px 10px;
  }
`;



const TopSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 410px) {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 15px;
  }
`;

const AccountCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border-left: 4px solid ${props => props.color || '#4CAF50'};
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 15px;
    border-radius: 12px;
  }
`;

const CardTitle = styled.h3`
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
  font-weight: 500;
  
  @media (max-width: 410px) {
    font-size: 14px;
    margin-bottom: 10px;
  }
`;

const CardAmount = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.color || '#333'};
  margin-bottom: 10px;
  word-break: break-word;
  overflow-wrap: break-word;
  
  @media (max-width: 410px) {
    font-size: 20px;
    margin-bottom: 8px;
  }
`;

const RankCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #FF9800;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 15px;
    border-radius: 12px;
  }
`;

const RankInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const RankTitle = styled.div`
  font-size: 16px;
  color: #666;
`;

const RankBadge = styled.span`
  background: ${props => props.color || (props.current ? '#666' : '#FF9800')};
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

const RankCondition = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 5px;
`;

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
  
  @media (max-width: 410px) {
    gap: 15px;
    margin-bottom: 15px;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: stretch;
`;

const ActionCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 15px;
    border-radius: 12px;
  }
`;

const ActionTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  
  @media (max-width: 410px) {
    font-size: 16px;
    margin-bottom: 15px;
  }
`;

const activityStatusColors = {
  active: '#2E7D32',
  pending: '#EF6C00',
  inactive: '#C62828',
  disabled: '#607D8B',
  default: '#4CAF50'
};

const activityStatusBackgrounds = {
  active: 'rgba(46, 125, 50, 0.12)',
  pending: 'rgba(239, 108, 0, 0.12)',
  inactive: 'rgba(198, 40, 40, 0.12)',
  disabled: 'rgba(96, 125, 139, 0.12)',
  default: 'rgba(76, 175, 80, 0.12)'
};

const progressColors = {
  active: '#4CAF50',
  pending: '#FF9800',
  inactive: '#F44336',
  lo: '#43A047',
  disabled: '#9E9E9E'
};

const ActivityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  gap: 16px;
`;

const ActivityStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${({ status }) => activityStatusColors[status] || activityStatusColors.default};
  background: ${({ status }) => activityStatusBackgrounds[status] || activityStatusBackgrounds.default};
`;

const ActivityStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 18px;
  
  @media (max-width: 410px) {
    gap: 12px;
    margin-bottom: 12px;
  }
`;

const ActivityStat = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 140px;
  
  @media (max-width: 410px) {
    min-width: 100px;
    flex: 1 1 calc(50% - 6px);
  }
`;

const ActivityStatLabel = styled.span`
  font-size: 12px;
  color: #777;
  margin-bottom: 4px;
`;

const ActivityStatValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

const ActivityProgressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
`;

const ProgressLabel = styled.div`
  font-size: 12px;
  color: #777;
  display: flex;
  justify-content: space-between;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 12px;
  border-radius: 999px;
  background: #f1f3f4;
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${({ percent }) => `${Math.max(0, Math.min(percent || 0, 100)).toFixed(2)}%`};
  background: ${({ status }) => progressColors[status] || progressColors.active};
  border-radius: inherit;
  transition: width 0.4s ease;
`;

const ActivityMessage = styled.div`
  margin-top: 6px;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ status }) => activityStatusColors[status] || activityStatusColors.default};
  background: ${({ status }) => activityStatusBackgrounds[status] || activityStatusBackgrounds.default};
  border-left: 3px solid ${({ status }) => progressColors[status] || progressColors.active};
`;

const ActivityFooter = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ActivityHintToggle = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #2e7d32;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    text-decoration: underline;
  }
`;

const ActivityHint = styled.div`
  background: #f1f8e9;
  border: 1px solid #c5e1a5;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 13px;
  color: #4a4a4a;
  line-height: 1.5;
`;

const MarketingCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const MarketingStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 15px;
  margin-bottom: 14px;
`;

const StatItem = styled.div`
  text-align: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
`;

const StatNumber = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 5px;
`;

const StatLabel = styled.div`
  font-size: 12px;
  color: #666;
`;

const ChartCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`;

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ChartTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin: 0;
`;

const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 10px;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #e2e8f0;
`;

const ChartSvg = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
  max-width: none;
  max-height: none;
`;

const ChartLine = styled.polyline`
  fill: none;
  stroke: #8B5CF6;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 2px 4px rgba(139, 92, 246, 0.3));
`;

const ChartDot = styled.circle`
  fill: ${props => props.isHovered ? '#7C3AED' : '#8B5CF6'};
  stroke: white;
  stroke-width: 2;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    fill: #7C3AED;
    r: 8;
  }
`;

const ChartGrid = styled.line`
  stroke: #E5E7EB;
  stroke-width: 1;
  opacity: 0.5;
`;

const ChartAxis = styled.line`
  stroke: #D1D5DB;
  stroke-width: 2;
`;

const ChartValue = styled.text`
  fill: #6B7280;
  font-size: 12px;
  font-weight: 500;
`;

const ChartLabel = styled.text`
  fill: #6B7280;
  font-size: 12px;
  font-weight: 500;
`;

const Tooltip = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  pointer-events: none;
  z-index: 1000;
  transform: translateX(-50%);
  white-space: nowrap;
`;

const TooltipDate = styled.div`
  color: #6B7280;
  margin-bottom: 4px;
`;

const TooltipValue = styled.div`
  color: #3B82F6;
  font-weight: 600;
`;


// Дополнительные блоки для нижней части
// Стили для блока покупок - красивая белая карточка
const PurchasesSection = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 15px;
    border-radius: 12px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
`;

const PurchasesTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
`;

const WithdrawSection = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
`;

const WithdrawTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 600;
`;

const WithdrawForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

const WithdrawInput = styled.input`
  flex: 0 0 160px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
`;

const WithdrawTextarea = styled.textarea`
  flex: 1 1 240px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  min-height: 60px;
  resize: vertical;
`;

const WithdrawButton = styled.button`
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: #10b981;
  color: white;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.2s ease, transform 0.1s ease, box-shadow 0.1s ease;

  &:hover:enabled {
    background: #059669;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

const WithdrawHint = styled.p`
  margin-top: 10px;
  font-size: 13px;
  color: #6b7280;
`;

const PurchasesTable = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e9ecef;
`;

const PurchaseRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s ease;
  
  &:last-child { 
    border-bottom: none; 
  }
  
  &:hover {
    background-color: #f1f3f4;
  }
  
  @media (max-width: 410px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px;
    font-size: 12px;
    align-items: flex-start;
  }
`;

const PurchaseCol = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  overflow: hidden;
  
  @media (max-width: 410px) {
    font-size: 11px;
    flex: 0 0 auto;
    
    & > span {
      display: block;
      white-space: nowrap;
    }
  }
`;

const PurchaseAction = styled.button`
  background: #ff6b35;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover { 
    background: #e55a2b;
    transform: translateY(-1px);
  }
  
  @media (max-width: 410px) {
    padding: 6px 12px;
    font-size: 11px;
    margin-left: auto;
    align-self: center;
  }
`;
const ReferralButton = styled.button`
  background: #ff6b35;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 100px;
  
  &:hover { 
    background: #e55a2b;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 410px) {
    padding: 10px 14px;
    font-size: 13px;
    min-width: auto;
  }
`;

// Стили для красивых белых карточек реферальной системы
const ReferralCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  width: 100%;
  box-sizing: border-box;
  
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 20px;
  }
  
  @media (max-width: 410px) {
    gap: 15px;
    margin-top: 20px;
  }
`;

const ReferralCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 15px;
    border-radius: 12px;
    gap: 12px;
  }
`;

const ReferralCardTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
  
  @media (max-width: 410px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const ReferralCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ReferralLinkCard = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  font-size: 14px;
  color: #333;
  word-break: break-all;
  overflow-wrap: break-word;
  border: 1px solid #e9ecef;
  font-family: 'Courier New', monospace;
  line-height: 1.4;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 410px) {
    padding: 12px;
    font-size: 11px;
    border-radius: 8px;
  }
`;

const QRCodeCard = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border: 1px solid #e9ecef;
  
  @media (max-width: 410px) {
    padding: 15px;
    gap: 15px;
    border-radius: 8px;
  }
`;

const QRCodeContainer = styled.div`
  background: white;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 410px) {
    padding: 10px;
    border-radius: 8px;
  }
`;

const ReferralButtonsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

// Функция для генерации дат за последние 7 дней
const generateLast7Days = () => {
  const dates = [];
  const today = new Date();
  
  for (let i = 6; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const formattedDate = date.toLocaleDateString('ru-RU', { 
      day: '2-digit', 
      month: '2-digit' 
    });
    dates.push({ date: formattedDate, value: 0 });
  }
  
  return dates;
};

// Функция для объединения данных с сервера с актуальными датами
const mergeChartData = (serverData) => {
  const defaultData = generateLast7Days();
  
  if (!serverData || serverData.length === 0) {
    return defaultData;
  }
  
  // Создаем карту данных с сервера для быстрого поиска
  const serverDataMap = new Map();
  serverData.forEach(item => {
    // Используем date как ключ (это formatted_date с сервера)
    serverDataMap.set(item.date, item.value);
  });
  
  // Объединяем данные
  return defaultData.map(defaultItem => {
    const serverValue = serverDataMap.get(defaultItem.date);
    return {
      date: defaultItem.date,
      value: serverValue !== undefined ? serverValue : 0
    };
  });
};

// Компонент графика приглашенных партнеров
const PartnersChart = ({ data = [] }) => {
  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  
  // Объединяем данные с сервера с актуальными датами
  const chartData = mergeChartData(data);

  const width = 600;
  const height = 170;
  const padding = 30;
  const chartWidth = width - padding * 2;
  const chartHeight = height - padding * 2;

  // Находим максимальное значение для масштабирования
  const maxValue = Math.max(...chartData.map(d => d.value), 1); // минимум 1 для избежания деления на 0
  const minValue = 0;
  const valueRange = maxValue - minValue;

  // Создаем точки для линии
  const points = chartData.map((d, index) => {
    const x = padding + (index * chartWidth) / (chartData.length - 1);
    const y = padding + chartHeight - ((d.value - minValue) / valueRange) * chartHeight;
    return `${x},${y}`;
  }).join(' ');

  // Горизонтальные линии сетки
  const gridLines = [];
  for (let i = 0; i <= 4; i++) {
    const y = padding + (i * chartHeight) / 4;
    const value = Math.round(maxValue - (i * valueRange) / 4);
    gridLines.push({ y, value });
  }
  
  // Обработчики событий для tooltip
  const hoverTimeoutRef = useRef(null);
  
  const handleMouseEnter = (event, point, index) => {
    // Очищаем предыдущий таймер
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    
    const rect = event.target.getBoundingClientRect();
    const containerRect = event.target.closest('[data-chart-container]').getBoundingClientRect();
    
    setHoveredPoint({ ...point, index });
    setTooltipPosition({
      x: rect.left - containerRect.left + rect.width / 2,
      y: rect.top - containerRect.top - 15
    });
  };
  
  const handleMouseLeave = () => {
    // Задержка перед скрытием для предотвращения мигания
    hoverTimeoutRef.current = setTimeout(() => {
      setHoveredPoint(null);
    }, 300);
  };

  return (
    <ChartCard>
      <ChartHeader>
        <ChartTitle>Приглашенные партнеры</ChartTitle>
      </ChartHeader>
      
      <ChartContainer data-chart-container>
        <ChartSvg viewBox={`0 0 ${width} ${height}`}>
          {/* Горизонтальные линии сетки */}
          {gridLines.map((line, index) => (
            <g key={index}>
              <ChartGrid
                x1={padding}
                y1={line.y}
                x2={width - padding}
                y2={line.y}
              />
              <ChartValue
                x={padding - 10}
                y={line.y + 5}
                textAnchor="end"
              >
                {line.value}
              </ChartValue>
            </g>
          ))}
          
          {/* Оси */}
          <ChartAxis
            x1={padding}
            y1={padding}
            x2={padding}
            y2={height - padding}
          />
          <ChartAxis
            x1={padding}
            y1={height - padding}
            x2={width - padding}
            y2={height - padding}
          />
          
          {/* Линия графика */}
          <ChartLine points={points} />
          
          {/* Точки на графике */}
          {chartData.map((d, index) => {
            const x = padding + (index * chartWidth) / (chartData.length - 1);
            const y = padding + chartHeight - ((d.value - minValue) / valueRange) * chartHeight;
            return (
              <ChartDot
                key={index}
                cx={x}
                cy={y}
                r="6"
                isHovered={hoveredPoint?.index === index}
                onMouseEnter={(e) => handleMouseEnter(e, d, index)}
                onMouseLeave={handleMouseLeave}
              />
            );
          })}
          
          {/* Подписи дат */}
          {chartData.map((d, index) => {
            const x = padding + (index * chartWidth) / (chartData.length - 1);
            return (
              <ChartLabel
                key={index}
                x={x}
                y={height - padding + 20}
                textAnchor="middle"
              >
                {d.date}
              </ChartLabel>
            );
          })}
        </ChartSvg>
        
        {/* Tooltip */}
        {hoveredPoint && (
          <Tooltip
            style={{
              left: tooltipPosition.x,
              top: tooltipPosition.y
            }}
          >
            <TooltipDate>{hoveredPoint.date}</TooltipDate>
            <TooltipValue>👥 {hoveredPoint.value} партнеров</TooltipValue>
          </Tooltip>
        )}
      </ChartContainer>
    </ChartCard>
  );
};


// Звания партнёрской программы (как на бэкенде QUALIFICATION_TITLES)
const QUALIFICATION_COLORS = {
  'Участник': '#6c757d',
  'Партнёр': '#28a745',
  'Координатор': '#17a2b8',
  'Организатор': '#20c997',
  'Наставник': '#ffc107',
  'Лидер': '#fd7e14',
  'Старший лидер': '#e83e8c',
  'Директор': '#6f42c1',
  'Партнёр компании': '#6610f2',
  'Совладелец': '#212529'
};

const Dashboard = () => {
  const { isAuthenticated, isSport, requestPartnerStatus, getUpgradeRequestStatus } = useAuth();
  const navigate = useNavigate();
  const [referralData, setReferralData] = useState(null);
  const [referralStats, setReferralStats] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [orders, setOrders] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [withdrawComment, setWithdrawComment] = useState('');
  const [isWithdrawSubmitting, setIsWithdrawSubmitting] = useState(false);
  const [missedRewards, setMissedRewards] = useState(null);
  
  // Состояние для заявки на статус Партнёр
  const [upgradeRequest, setUpgradeRequest] = useState(null);
  const [upgradeRequestLoading, setUpgradeRequestLoading] = useState(false);
  
  // Определяем статус пользователя (Спорт или Партнёр). Блок «Подать заявку» только для Спорт; у Партнёров не показываем.
  const userIsSport = false;
  
  // ЛО/ГО для отображения объёмов (не для старой лестницы «Консультант»)
  const userLO = userProfile ? (userProfile.personalVolume || userProfile.personal_volume || 0) : 0;
  const userGO = userProfile ? (userProfile.groupVolume || userProfile.group_volume || 0) : 0;
  
  // #region agent log
  React.useEffect(() => {
    if (userProfile) {}
  }, [userProfile, userLO, userGO]);
  // #endregion
  
  const marketingQual = userProfile?.marketingQualification;
  const qualificationTitle = marketingQual?.title || 'Участник';
  const qualificationColor = QUALIFICATION_COLORS[qualificationTitle] || '#6c757d';
  const qualificationProgress = marketingQual?.progress;
  const nextQualificationTitle = qualificationProgress?.nextTitle || null;
  const nextQualificationColor = nextQualificationTitle
    ? (QUALIFICATION_COLORS[nextQualificationTitle] || '#6c757d')
    : '#6c757d';

  const canRequestWithdrawal =
    !userIsSport &&
    userProfile &&
    (userProfile.documentsVerified === true || userProfile.documents_verified === true) &&
    (userProfile.points || 0) > 0;

  // Функция загрузки данных графика за последнюю неделю
  const loadChartData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      const response = await fetch('/api/referrals/chart-data?period=week', { headers });
      
      if (response.ok) {
        const result = await response.json();
        setChartData(result.data || []);
      } else {
        console.log('Failed to load chart data:', response.status);
        setChartData([]);
      }
    } catch (err) {
      console.log('Error loading chart data:', err);
      setChartData([]);
    }
  };

  // Загрузка реферальных данных
  useEffect(() => {
    const loadReferralData = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };

        // Загружаем реферальный код и ссылку
        try {
          const referralResponse = await fetch('/api/referrals/my-code', { headers });
          if (referralResponse.ok) {
            const referralData = await referralResponse.json();
            setReferralData(referralData);
          } else {
            console.log('Failed to load referral code:', referralResponse.status);
          }
        } catch (err) {
          console.log('Error loading referral code:', err);
        }

        // Загружаем статистику
        try {
          const statsResponse = await fetch('/api/referrals/stats', { headers });
          if (statsResponse.ok) {
            const statsData = await statsResponse.json();
            console.log('Frontend received referral stats:', statsData);
            setReferralStats(statsData);
          } else {
            console.log('Failed to load referral stats:', statsResponse.status);
          }
        } catch (err) {
          console.log('Error loading referral stats:', err);
        }

        // Загружаем данные для графика
        await loadChartData();

        // Загружаем заказы пользователя
        try {
          const ordersResponse = await fetch(`${SERVER_BASE_URL}/api/orders?limit=5`, { headers });
          if (ordersResponse.ok) {
            const ordersData = await ordersResponse.json();
            const receivedOrders = ordersData.data?.orders || [];
            const paidOrders = receivedOrders.filter(o => o?.paymentStatus === 'paid');
            setOrders(paidOrders);
          } else {
            console.log('Failed to load orders:', ordersResponse.status);
          }
        } catch (err) {
          console.log('Error loading orders:', err);
        }

        // Загружаем профиль пользователя (включая баллы)
        try {
          const profileResponse = await fetch(`${SERVER_BASE_URL}/api/auth/profile`, { headers });

          if (profileResponse.ok) {
            const profileData = await profileResponse.json();
            setUserProfile(profileData.user);
          } else {
            console.log('Failed to load user profile:', profileResponse.status);
          }
        } catch (err) {
          console.log('Error loading user profile:', err);
        }

        try {
          const missedRes = await fetch(`${SERVER_BASE_URL}/api/marketing/dashboard`, { headers });
          if (missedRes.ok) {
            const missedData = await missedRes.json();
            setMissedRewards(missedData.missed || null);
          }
        } catch (err) {
          console.log('Error loading marketing data:', err);
        }

      } catch (error) {
        console.error('Error loading referral data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated()) {
      loadReferralData();
    }
  }, [isAuthenticated]);

  // Загружаем статус заявки на повышение для пользователей Спорт
  useEffect(() => {
    const loadUpgradeRequestStatus = async () => {
      if (userIsSport && getUpgradeRequestStatus) {
        try {
          const result = await getUpgradeRequestStatus();
          if (result.success) {
            setUpgradeRequest(result.data);
          }
        } catch (err) {
          console.log('Error loading upgrade request status:', err);
        }
      }
    };
    
    if (isAuthenticated()) {
      loadUpgradeRequestStatus();
    }
  }, [isAuthenticated, userIsSport, getUpgradeRequestStatus]);

  // Функция для подачи заявки на статус Партнёр
  const handleRequestPartnerStatus = async () => {
    if (!requestPartnerStatus) return;
    
    setUpgradeRequestLoading(true);
    try {
      const result = await requestPartnerStatus('Хочу стать Партнёром Lagom Life: персональная ссылка и линейные начисления с заказов приглашённых');
      if (result.success) {
        setUpgradeRequest(result.data?.data);
        alert('Заявка успешно отправлена! Ожидайте рассмотрения администратором.');
      } else {
        alert(result.message || 'Ошибка при отправке заявки');
      }
    } catch (err) {
      alert('Ошибка при отправке заявки');
    } finally {
      setUpgradeRequestLoading(false);
    }
  };

  // Функция копирования в буфер обмена
  const copyToClipboard = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`${type} скопирован в буфер обмена!`);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        alert(`${type} скопирован в буфер обмена!`);
      } catch (fallbackErr) {
        console.error('Fallback: Oops, unable to copy', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  // Функция скачивания QR-кода
  const downloadQRCode = () => {
    try {
      // Находим SVG элемент QR-кода
      const qrCodeElement = document.querySelector('[data-qr-code] svg');
      if (!qrCodeElement) {
        alert('QR-код не найден');
        return;
      }

      // Получаем SVG как строку
      const svgData = new XMLSerializer().serializeToString(qrCodeElement);
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);

      // Создаем canvas для конвертации SVG в PNG
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        
        // Конвертируем canvas в blob и скачиваем
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'qr-code.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          URL.revokeObjectURL(svgUrl);
        }, 'image/png');
      };

      img.onerror = () => {
        alert('Ошибка при создании изображения QR-кода');
        URL.revokeObjectURL(svgUrl);
      };

      img.src = svgUrl;
    } catch (error) {
      console.error('Error downloading QR code:', error);
      alert('Ошибка при скачивании QR-кода');
    }
  };

  // const today = new Date().toLocaleDateString('ru-RU', { 
  //   year: 'numeric', 
  //   month: 'long', 
  //   day: 'numeric' 
  // });

  // Если пользователь не авторизован, перенаправляем на главную
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const handleWithdrawSubmit = async (e) => {
    e.preventDefault();
    if (!userProfile) return;
    const points = parseInt(withdrawAmount || '0', 10);
    if (!points || points <= 0) {
      alert('Введите корректную сумму баллов для вывода');
      return;
    }
    if (points > (userProfile.points || 0)) {
      alert('Нельзя запросить к выводу больше, чем доступный баланс баллов');
      return;
    }
    setIsWithdrawSubmitting(true);
    try {
      const response = await fetch('/api/withdrawals', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({
          amountPoints: points,
          comment: withdrawComment
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.success === false) {
        throw new Error(data.message || 'Ошибка отправки заявки');
      }
      alert(data.message || 'Заявка на вывод средств отправлена');
      setWithdrawAmount('');
      setWithdrawComment('');
    } catch (error) {
      console.error('Withdraw request error:', error);
      alert(error.message || 'Ошибка при создании заявки на вывод');
    } finally {
      setIsWithdrawSubmitting(false);
    }
  };

  return (
    <DashboardWrapper>
      <DashboardHeader />
      <DashboardContainer>
        

        <MarketingInfoCard>
          <h4>Структура вознаграждений Lagom Life</h4>
          <p>
            Линейный бонус сейчас — <strong>5% с заказов лично приглашённых</strong> (1-й уровень).
            Начисление сразу после оплаты заказа. Подробности программы — на странице партнёрства.
          </p>
          <a href="/referral">Подробнее о партнёрской программе →</a>
        </MarketingInfoCard>

        {/* Блок "Стать Партнёром" для статуса Спорт */}
        {userIsSport && (
          <BecomePartnerCard>
            <BecomePartnerTitle>
              {upgradeRequest?.status === 'pending' 
                ? '🕐 Заявка на рассмотрении' 
                : '🚀 Станьте Партнёром!'}
            </BecomePartnerTitle>
            <BecomePartnerText>
              {upgradeRequest?.status === 'pending'
                ? 'Ваша заявка отправлена администратору. Ожидайте решения.'
                : 'Получите доступ к партнёрской программе Lagom Life: персональная ссылка, начисления с заказов и статистика команды'}
            </BecomePartnerText>
            {(!upgradeRequest || upgradeRequest.status === 'rejected') && (
              <BecomePartnerButton 
                onClick={handleRequestPartnerStatus}
                disabled={upgradeRequestLoading}
              >
                {upgradeRequestLoading ? 'Отправка...' : 'ПОДАТЬ ЗАЯВКУ'}
              </BecomePartnerButton>
            )}
            {upgradeRequest?.status === 'rejected' && (
              <p style={{ marginTop: '10px', fontSize: '12px', opacity: 0.8 }}>
                Предыдущая заявка была отклонена. Вы можете подать новую.
              </p>
            )}
          </BecomePartnerCard>
        )}

        <TopSection>
          {/* ЛО и ГО только для Партнёров */}
          {!userIsSport && (
            <>
              <AccountCard color="#4CAF50">
                <CardTitle>
                  ЛО — личный объём
                  {userProfile?.volumePeriod?.label ? ` (${userProfile.volumePeriod.label})` : ''}
                </CardTitle>
                <CardAmount color="#4CAF50">
                  {userProfile ? `${((userProfile.personalVolume || userProfile.personal_volume || 0)).toLocaleString('ru-RU')} баллов` : 'Загрузка...'}
                </CardAmount>
              </AccountCard>

              <AccountCard color="#9C27B0">
                <CardTitle>
                  ГО — групповой объём
                  {userProfile?.volumePeriod?.label ? ` (${userProfile.volumePeriod.label})` : ''}
                </CardTitle>
                <CardAmount color="#9C27B0">
                  {userProfile ? `${((userProfile.groupVolume || userProfile.group_volume || 0)).toLocaleString('ru-RU')} баллов` : 'Загрузка...'}
                </CardAmount>
              </AccountCard>
            </>
          )}

          <AccountCard color="#2196F3">
            <CardTitle>Бонусный счет</CardTitle>
            <CardAmount color="#2196F3">
              {userProfile ? `${userProfile.points || 0} баллов` : 'Загрузка...'}
            </CardAmount>
          </AccountCard>

          {/* Текущий статус только для Партнёров */}
          {!userIsSport && (
            <RankCard>
              <RankInfo>
                <div>
                  <RankTitle>
                    Звание — <RankBadge color={qualificationColor}>{qualificationTitle}</RankBadge>
                  </RankTitle>
                  <RankCondition>
                    {qualificationProgress && !qualificationProgress.complete
                      ? `До ${qualificationProgress.nextTitle}: ${qualificationProgress.hints?.map((h) => `${h.label} ${h.current}/${h.required}`).join(' · ') || ''}`
                      : 'Условия текущего звания выполнены'}
                  </RankCondition>
                </div>
              </RankInfo>
              <RankInfo>
                <div>
                  <RankTitle>
                    {qualificationProgress?.complete ? (
                      <span style={{ color: '#999', fontSize: '12px' }}>Максимальное звание</span>
                    ) : (
                      <>Следующее — <RankBadge color={nextQualificationColor}>{nextQualificationTitle || '—'}</RankBadge></>
                    )}
                  </RankTitle>
                </div>
              </RankInfo>
            </RankCard>
          )}
        </TopSection>

        <MainContent>
          <LeftColumn>
            {/* Блок «Активность / порог 5000» скрыт — в текущей программе не используется в UI */}

            {!userIsSport && missedRewards && (
            <ActionCard>
              <ActionTitle>Упущенное вознаграждение (превью)</ActionTitle>
              <ActivityStats>
                <ActivityStat>
                  <ActivityStatLabel>Всего</ActivityStatLabel>
                  <ActivityStatValue>{Math.round(missedRewards.missed_total || 0)} баллов</ActivityStatValue>
                </ActivityStat>
                <ActivityStat>
                  <ActivityStatLabel>Линейный</ActivityStatLabel>
                  <ActivityStatValue>{Math.round(missedRewards.missed_linear || 0)}</ActivityStatValue>
                </ActivityStat>
                <ActivityStat>
                  <ActivityStatLabel>Прочие типы (если были)</ActivityStatLabel>
                  <ActivityStatValue>
                    {Math.round((missedRewards.missed_mentor || 0) + (missedRewards.missed_leader || 0) + (missedRewards.missed_company || 0))}
                  </ActivityStatValue>
                </ActivityStat>
              </ActivityStats>
              <ActivityMessage status="pending">
                {missedRewards.is_preview !== false
                  ? 'Предварительный расчёт до закрытия периода.'
                  : 'Расчёт за закрытый период.'}{' '}
                <a href="/marketing">Подробнее →</a>
              </ActivityMessage>
            </ActionCard>
            )}

            {/* Автоактивность скрыта вместе с порогом активности */}

            {/* Для Спорта показываем только 1 линию рефералов */}
            {userIsSport && (
            <MarketingCard>
              <ActionTitle>Ваша команда</ActionTitle>
              <MarketingStats>
                <StatItem>
                  <StatNumber>{referralStats ? referralStats.directReferrals : 0}</StatNumber>
                  <StatLabel>Рефералов 1 линии</StatLabel>
                </StatItem>
              </MarketingStats>
              <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', textAlign: 'center' }}>
                Станьте Партнёром для доступа к полной партнёрской программе Lagom Life
              </p>
            </MarketingCard>
            )}
          </LeftColumn>

          <RightColumn>
            <PartnersChart data={chartData} />
          </RightColumn>
        </MainContent>

        {/* Последние покупки */}
        <PurchasesSection>
          <PurchasesTitle>Последние покупки</PurchasesTitle>
          <PurchasesTable>
            {orders.length > 0 ? (
              orders.slice(0, 5).map((order, idx) => {
                const orderDate = new Date(order.createdAt).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                });
                
                return (
                  <PurchaseRow key={order.id}>
                    <PurchaseCol>
                      <div style={{fontWeight: '600'}}>№: {order.orderNumber}</div>
                      <div style={{fontSize: '12px', color: '#666'}}>
                        Статус: {(() => {
                          const statusMap = {
                            'pending': 'Новый',
                            'processing': 'В обработке',
                            'shipped': 'Отправлен',
                            'ready_for_pickup': 'Готов к выдаче',
                            'delivered': 'Доставлен',
                            'cancelled': 'Отменен'
                          };
                          return statusMap[order.status] || order.status;
                        })()}
                      </div>
                    </PurchaseCol>
                    <PurchaseCol>
                      <div>Дата: {orderDate}</div>
                    </PurchaseCol>
                    <PurchaseCol>
                      <div style={{fontWeight: '600'}}>Сумма: {order.totalAmount.toFixed(2)} ₽</div>
                    </PurchaseCol>
                    <PurchaseCol style={{flex: '0 0 120px'}}>
                      <PurchaseAction onClick={() => navigate('/dashboard/orders-history')}>
                        ПРОСМОТРЕТЬ
                      </PurchaseAction>
                    </PurchaseCol>
                  </PurchaseRow>
                );
              })
            ) : (
              <PurchaseRow style={{textAlign: 'center', padding: '20px'}}>
                <PurchaseCol style={{flex: '1', textAlign: 'center', color: '#666'}}>
                  У вас пока нет заказов
                </PurchaseCol>
              </PurchaseRow>
            )}
          </PurchasesTable>
        </PurchasesSection>

        {/* Заявка на вывод средств (для партнёров с верифицированными документами) */}
        {canRequestWithdrawal && (
          <WithdrawSection>
            <WithdrawTitle>Заявка на вывод средств</WithdrawTitle>
            <WithdrawForm onSubmit={handleWithdrawSubmit}>
              <WithdrawInput
                type="number"
                min="1"
                max={userProfile?.points || 0}
                placeholder="Сумма баллов"
                value={withdrawAmount}
                onChange={(e) => setWithdrawAmount(e.target.value)}
              />
              <WithdrawTextarea
                placeholder="Комментарий (реквизиты, удобный способ связи и т.п.)"
                value={withdrawComment}
                onChange={(e) => setWithdrawComment(e.target.value)}
              />
              <WithdrawButton type="submit" disabled={isWithdrawSubmitting}>
                {isWithdrawSubmitting ? 'Отправка...' : 'Отправить заявку'}
              </WithdrawButton>
            </WithdrawForm>
            <WithdrawHint>
              Доступно для вывода: {userProfile?.points || 0} баллов. Заявка будет рассмотрена менеджером, после чего с вами свяжутся для уточнения деталей выплаты.
            </WithdrawHint>
          </WithdrawSection>
        )}
        <h2 style={{fontSize: '1.6rem', fontWeight: '700', color: '#333', marginTop: '40px', marginBottom: '24px'}}>Ссылки для новых участников</h2>
        {referralData ? (
          <ReferralCardsContainer>
            <ReferralCard>
              <ReferralCardTitle>Реферальная ссылка</ReferralCardTitle>
              <ReferralCardContent>
                <ReferralLinkCard>
                  {referralData.referralLink}
                </ReferralLinkCard>
              </ReferralCardContent>
            </ReferralCard>
            
            <ReferralCard>
              <ReferralCardTitle>QR-код и действия</ReferralCardTitle>
              <ReferralCardContent>
                <QRCodeCard>
                  <QRCodeContainer data-qr-code>
                    <QRCode value={referralData.referralLink} size={100} />
                  </QRCodeContainer>
                  <ReferralButtonsCard>
                    <ReferralButton onClick={() => copyToClipboard(referralData.referralLink, 'Реферальная ссылка')}>
                      СКОПИРОВАТЬ ССЫЛКУ
                    </ReferralButton>
                    <ReferralButton onClick={downloadQRCode}>
                      СКАЧАТЬ QR-КОД
                    </ReferralButton>
                  </ReferralButtonsCard>
                </QRCodeCard>
              </ReferralCardContent>
            </ReferralCard>
          </ReferralCardsContainer>
        ) : (
          <div style={{textAlign: 'center', padding: '20px', color: '#666'}}>
            {loading ? 'Загрузка реферальных данных...' : 'Ошибка загрузки реферальных данных'}
          </div>
        )}
      </DashboardContainer>
      <DashboardFooter />
    </DashboardWrapper>
  );
};

export default Dashboard; 